import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [buttonText, setButtonText] = useState('Respawn at Home');
  const [controllerTilt, setControllerTilt] = useState(0);

  const handleMouseOver = () => setControllerTilt(10);
  const handleMouseOut = () => setControllerTilt(0);

  const handleButtonClick = () => {
    setButtonText('Teleporting... 🎮');
    setTimeout(() => navigate('/'), 700);
  };

  return (
    <div className="notfound-page page-with-navbar-footer">
      <Navbar />
      <main style={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #181818 0%, #23272f 100%)',
        color: '#fff',
        textAlign: 'center',
        padding: '2rem',
      }}>
        {/* Pixel art or SVG game controller */}
        <div
          style={{
            marginBottom: 24,
            transform: `rotate(${controllerTilt}deg)`,
            transition: 'transform 0.2s',
            display: 'inline-block',
          }}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
        >
          <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="30" width="100" height="40" rx="20" fill="#222" stroke="#FFD700" strokeWidth="4"/>
            <circle cx="35" cy="50" r="8" fill="#e94560"/>
            <circle cx="85" cy="50" r="8" fill="#43e97b"/>
            <rect x="55" y="45" width="10" height="4" rx="2" fill="#FFD700"/>
            <rect x="58" y="42" width="4" height="10" rx="2" fill="#FFD700"/>
            <ellipse cx="60" cy="70" rx="30" ry="6" fill="#111" opacity="0.3"/>
          </svg>
        </div>
        <h1 style={{ fontSize: '3rem', margin: '1rem 0 0.5rem', fontFamily: 'Orbitron, monospace' }}>
          404: Game Over!
        </h1>
        <p style={{ fontSize: '1.3rem', marginBottom: '2rem', color: '#FFD700', maxWidth: 500 }}>
          Oops! You just hit a secret level... but there's nothing here. <br/>
          Maybe the page got <span style={{ color: '#e94560' }}>rekt</span> or is still loading XP.<br/>
          <span style={{ color: '#43e97b' }}>Press the button to respawn at home!</span>
        </p>
        <button
          onClick={handleButtonClick}
          onMouseOver={() => setButtonText('Ready? Respawn!')}
          onMouseOut={() => setButtonText('Respawn at Home')}
          style={{
            background: 'linear-gradient(90deg, #e94560 0%, #FFD700 100%)',
            color: '#181818',
            border: 'none',
            borderRadius: '30px',
            padding: '0.9rem 2.5rem',
            fontSize: '1.2rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 4px 16px rgba(233,69,96,0.2)',
            transition: 'background 0.2s, color 0.2s',
            outline: 'none',
          }}
        >
          {buttonText}
        </button>
        <div style={{ marginTop: 32, fontSize: '1rem', color: '#c7c7c7' }}>
          <span role="img" aria-label="joystick">🕹️</span> Cheda Gaming &mdash; Level up, don’t get lost!
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage; 